module.exports = __webpack_public_path__ + "assets/akamai-global-host.069a9272.svg";